import React from 'react';
import { ErrorMessage, Field } from 'formik';
import AsyncSelect from 'react-select/async';
import useFieldDecorators from '../hooks/useFieldDecorators';
import Tooltip from '../common/Tooltip';
const AsyncSelectField = (props) => {
    const { isRequired, helpBlock, contentCssClass, labelCssClass } = useFieldDecorators(props);
    return (React.createElement("div", { className: "form-group row" },
        React.createElement("label", { htmlFor: props.name, className: `${labelCssClass} control-label` },
            isRequired,
            props.label,
            " \u00A0",
            React.createElement(Tooltip, { text: props.tooltip, name: props.name })),
        React.createElement("div", { className: contentCssClass },
            React.createElement(Field, { type: "select", name: props.name }, ({ form }) => (React.createElement(AsyncSelect, Object.assign({ name: props.name, inputId: props.name, onChange: (option) => {
                    const value = option ? option.value : '';
                    if (props.onChange) {
                        props.onChange(option);
                    }
                    form.setFieldValue(props.name, value);
                }, "data-testid": props.testId, defaultOptions: props.defaultValue
                    ? [
                        {
                            label: props.defaultValue.label,
                            value: props.defaultValue.value,
                            data: '',
                        },
                    ]
                    : undefined, defaultValue: props.defaultValue
                    ? {
                        label: props.defaultValue.label,
                        value: props.defaultValue.value,
                        data: '',
                    }
                    : undefined }, props.asyncSelectProps)))),
            React.createElement(ErrorMessage, { name: props.name, className: "text-danger", component: "small" }),
            helpBlock)));
};
export default AsyncSelectField;
